// Custom events - Stiletto theme

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
});
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
});
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
});
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
});
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
});
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
});
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


// ============================================================
// KİŞİYE ÖZEL ÜRÜN - DOSYA YÜKLEME DESTEĞİ
// ============================================================

document.addEventListener('DOMContentLoaded', function () {
  var uploadForms = document.querySelectorAll('form[enctype="multipart/form-data"]');

  uploadForms.forEach(function (form) {
    var fileInput = form.querySelector('input[type="file"][name^="properties"]');
    if (!fileInput) return;

    var submitBtn = form.querySelector('[data-add-to-cart], button[type="submit"][name="add"]');
    if (!submitBtn) return;

    form.addEventListener('submit', function (e) {
      var hasFile = fileInput.files && fileInput.files.length > 0;
      var errorBox = form.querySelector('.product-custom-upload__error');

      if (!hasFile) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (errorBox) {
          errorBox.style.display = 'block';
          fileInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }

      // Dosya var — Stiletto'yu durdur, kendimiz gönderelim
      e.preventDefault();
      e.stopImmediatePropagation();
      if (errorBox) errorBox.style.display = 'none';

      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');

      // Önce Shopify token'ını taze al, sonra cart/add yap
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function() {
          var formData = new FormData(form);

          // Quick-cart section'ını bul
          var quickCartEl = document.querySelector('[data-section-type="quick-cart"]');
          var sectionId = quickCartEl ? quickCartEl.dataset.sectionId : null;
          if (sectionId) {
            formData.append('sections[]', sectionId);
            formData.append('sections_url', window.location.pathname);
          }

          // Shopify'ın beklediği zorunlu alanlar
          var variantId = form.querySelector('[name="id"]') 
            ? form.querySelector('[name="id"]').value 
            : null;
          
          if (!variantId) {
            // Dışarıdaki variant selector'dan al
            var outerVariant = document.querySelector('.product-variant-id');
            if (outerVariant) variantId = outerVariant.value;
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(response) {
          if (response.status) {
            console.error('Cart add error:', response.description);
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('aria-disabled');
            return;
          }

          console.log('Success! Response:', response);

          // Header sepet sayacını güncelle
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var counters = document.querySelectorAll('[data-js-cart-count]');
              counters.forEach(function(el) { el.textContent = cart.item_count; });
            });

          // Quick-cart section'ını güncelle
          var quickCartEl = document.querySelector('[data-section-type="quick-cart"]');
          var sectionId = quickCartEl ? quickCartEl.dataset.sectionId : null;

          var openCart = function() {
            var quickCart = document.querySelector('.quick-cart');
            if (quickCart) {
              quickCart.classList.add('animation--quick-cart-revealed');
              document.body.setAttribute('data-fluorescent-overlay-open', 'true');
            }
            submitBtn.classList.remove('loading');
            submitBtn.removeAttribute('aria-disabled');
          };

          if (sectionId && response.sections && response.sections[sectionId]) {
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(response.sections[sectionId], 'text/html');
            var newInner = newDoc.querySelector('.quick-cart__container');
            var currInner = document.querySelector('.quick-cart__container');
            if (newInner && currInner) {
              currInner.innerHTML = newInner.innerHTML;
            }
            openCart();
          } else {
            // Section ayrı çek
            fetch('/?section_id=' + sectionId, {
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            .then(function(r) { return r.text(); })
            .then(function(html) {
              var parser = new DOMParser();
              var newDoc = parser.parseFromString(html, 'text/html');
              var newInner = newDoc.querySelector('.quick-cart__container');
              var currInner = document.querySelector('.quick-cart__container');
              if (newInner && currInner) {
                currInner.innerHTML = newInner.innerHTML;
              }
              openCart();
            });
          }
        })
        .catch(function(err) {
          console.error('Upload error:', err);
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
        });

    }, true);
  });
});